import React from 'react';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

import { FaArrowLeft } from 'react-icons/fa';

const FeaturesPage = () => {
    return (
        <div className="features-page">
            <nav className="navbar" style={{ padding: '1rem 0', background: 'var(--background)' }}>
                <div className="container">
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'bold', color: 'var(--primary)' }}>
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </Link>
                </div>
            </nav>
            <Features />
            <Footer />
        </div>
    );
};

export default FeaturesPage;
